<template>
	<div>
		<v-dialog v-model="dialogAddSection" no-click-animation persistent lazy full-width width="290px" transition="dialog-bottom-transition">
        	<v-card>
        	  	<v-card-text>
        	  		<v-form data-vv-scope="section">
        	  			<v-text-field 
        	  				id="sectionNameField" 
        	  				v-model="section.sectionName" 
        	  				placeholder=" " 
        	  				label="Section Name" 
        	  				v-validate="'required'" 
        	  				data-vv-name="sectionName" 
        	  				:error-messages="errors.collect('section.sectionName')" 
        	  				required>
        	  					
        	  			</v-text-field>
        	  		</v-form>
        	  	</v-card-text>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog()">close</v-btn>
		          <v-btn color="blue darken-1" flat @click.native="fn_isValid">ok</v-btn>
		        </v-card-actions>
	        	</v-card>	
      	</v-dialog>
	</div>
</template>

<script>
export default{
	props:['updateSectionList', 'updateSection', 'sectionList', 'addSection'],
	data(){	
		return{
			dialogAddSection: false,
			section: {sectionId:null, sectionName:null},
		}
	},
	methods:{
		openDialogWeb: function () {
			setTimeout(function () {
				document.getElementById('sectionNameField').focus();
			},300);
			this.errors.remove('section.sectionName');
			this.dialogAddSection = true;
		},
		closeDialogWeb: function () {
			this.dialogAddSection = false;
			this.section = {sectionId:null, sectionName:null};
		},
		fn_isValid: function () {
			var self = this;
		    this.$validator.validateAll('section').then((result) => {
		        if (result) {
		        	!self.section.sectionId ? self.section.sectionId = self.guid() : '';
		        	self.addSection(self.section);
		        }
		    });
		}
	},
	mounted: function () {
		this.$eventHub.$on('editSection', section => {
	    	this.section = JSON.parse(JSON.stringify(section));
	    });
	}
}
</script>


// WEBPACK FOOTER //
// src/components/fields/dialog_section_form.vue